module.exports = __webpack_public_path__ + "static/media/top-bg.9c18013d.png";